import styled, { css } from 'styled-components';
import { getTextPresetCss } from '@optimus-web/common';
import {
    BannerVariant,
    BORDER_RADIUS,
    Component,
    Decision,
    getComponentToken,
    getComponentVariableToken,
    SPACING,
    TEXT_PRESET_KEY,
} from '@optimus-web/local-tokens';
import theme from '@optimus-web/theme';
import { BareIconButton } from '../BareIconButton';
import { Icon } from '../Icon';
import { getTypographyOptions, TypographyOptions } from '../typography';

const getBannerToken = getComponentVariableToken(Component.Banner, 'variant');
const getBannerPrimaryTextToken = getComponentToken(Component.BannerPrimaryText);
const getBannerSecondaryTextToken = getComponentToken(Component.BannerSecondaryText);

interface BannerElementProps {
    variant: BannerVariant;
    attached?: boolean;
    centered?: boolean;
}

interface BannerInnerElementProps {
    showIcon: boolean;
}

export const BannerElement = styled.div<BannerElementProps>`
    color: ${getBannerToken(Decision.Color)};
    background-color: ${getBannerToken(Decision.BackgroundColor)};
    display: flex;
    border-radius: ${BORDER_RADIUS[100]};

    ${(props) =>
        props.centered &&
        `
        justify-content: center;
    `}
`;

BannerElement.defaultProps = {
    theme,
};

export const BannerInnerElement = styled.div<BannerInnerElementProps>`
    display: flex;
    align-items: center;
    padding: ${SPACING[200]}px;

    ${(props) =>
        props.showIcon &&
        css`
            & > :last-child {
                margin-left: ${SPACING[200]}px;
                flex-grow: 1;
            }
        `}
`;

interface PrimaryTextElementProps extends TypographyOptions {
    hasSecondaryText: boolean;
}

export const PrimaryTextElement = styled.span<PrimaryTextElementProps>`
    ${(props) => getTextPresetCss(TEXT_PRESET_KEY[props.hasSecondaryText ? '300m' : '200m'])}
    color: ${getBannerPrimaryTextToken(Decision.Color)};
    ${getTypographyOptions}
`;

PrimaryTextElement.defaultProps = {
    theme,
};

export const SecondaryTextElement = styled.div<TypographyOptions>`
    margin-top: 4px;
    ${getTextPresetCss(TEXT_PRESET_KEY['200r'])}
    color: ${getBannerSecondaryTextToken(Decision.Color)};
    a {
        font-weight: ${getTextPresetCss(TEXT_PRESET_KEY['200r'])};
    }
    ${getTypographyOptions}
`;

SecondaryTextElement.defaultProps = {
    theme,
};

export const BannerIconElement = styled(Icon)`
    margin: -2px 0;
`;

export const BannerCloseIcon = styled(BareIconButton)`
    margin-left: 16px;
    vertical-align: middle;
`;
